import Modal from './Modal';
import useSWR from 'swr';
import { useModal } from '../contexts';
import { WorkflowFolder } from '../interfaces';
import { getData, postData } from '../backend';
import { FolderIcon, UserIcon } from '@heroicons/react/solid';
import { luminance } from '../utils';
import { FolderAddIcon, FolderRemoveIcon } from '@heroicons/react/outline';
import FolderModal from './FolderModal';

interface Props {
  selectFolder: (folder: WorkflowFolder | null) => void;
  titleText?: string;
  showRemoveFolder?: boolean;
  showCreateFolder?: boolean;
}

function FolderPickerModal(props: Props) {
  const { data: folders, mutate: mutateFolders } = useSWR<Array<WorkflowFolder>>("/workflows/folders/", getData, { fallbackData: [] });
  const { openModal, closeModal } = useModal();

  function handleAddFolder(folder: WorkflowFolder) {
    mutateFolders(prev => [...(prev ?? []), folder], { revalidate: false });
    openModal(<FolderPickerModal {...props} />)

    postData("/workflows/folders/", folder)
      .then(() => mutateFolders((prev) => prev!.map(f => f.id === folder.id ? folder : f)))
      .catch((e) => console.error(e));
  }

  function handleCreateFolder() {
    openModal(<FolderModal updateFolder={handleAddFolder} />);
  }

  return (
    <Modal
      title={props.titleText ?? "Select Folder"}
      secondaryButtonProps={{ text: "Cancel", onClick: closeModal }}
    >
      <div className='h-[320px] w-full overflow-y-auto'>
        {props.showRemoveFolder &&
          <div className='flex items-center group w-full hover:bg-blue-50 cursor-pointer' onClick={() => props.selectFolder(null)}>
            <div className="flex justify-center items-center w-10 h-10 rounded select-none relative text-gray-400">
              <FolderRemoveIcon className="w-8 h-8" />
            </div>
            <div className="flex items-center group cursor-pointer rounded h-full px-2 font-semibold text-gray-600">
              Remove Folder
            </div>
          </div>
        }

        {props.showCreateFolder &&
          <div className='flex items-center group w-full hover:bg-blue-50 cursor-pointer' onClick={() => handleCreateFolder()}>
            <div className="flex justify-center items-center w-10 h-10 rounded select-none relative text-gray-400">
              <FolderAddIcon className="w-8 h-8" />
            </div>
            <div className="flex items-center group cursor-pointer rounded h-full px-2 font-semibold text-gray-600">
              Create Folder
            </div>
          </div>
        }

        {folders?.map((folder) =>
          <div key={folder.id} className={`flex items-center group w-full ${folder.id ? "hover:bg-blue-50 cursor-pointer" : "text-gray-400"} `} onClick={() => { return !!folder.id ? props.selectFolder(folder) : undefined }}>
            <div className="flex justify-center items-center w-10 h-10 rounded select-none relative " style={{ color: folder.color }}>
              <FolderIcon className="w-8 h-8" />
              {folder.team &&
                <UserIcon className="absolute w-3 h-3 bottom-3 right-2.5" style={{ color: luminance(folder.color) > 0 ? "white" : "black" }} />
              }
            </div>
            <div className="flex items-center group cursor-pointer rounded h-full px-2 font-semibold text-gray-600">
              {folder.name}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default FolderPickerModal;
